/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OutputPilotData
 */
export interface OutputPilotData {
    /**
     * 
     * @type {number}
     * @memberof OutputPilotData
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof OutputPilotData
     */
    name?: string;
}

/**
 * Check if a given object implements the OutputPilotData interface.
 */
export function instanceOfOutputPilotData(value: object): boolean {
    return true;
}

export function OutputPilotDataFromJSON(json: any): OutputPilotData {
    return OutputPilotDataFromJSONTyped(json, false);
}

export function OutputPilotDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutputPilotData {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
    };
}

export function OutputPilotDataToJSON(value?: OutputPilotData | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'name': value['name'],
    };
}

